/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ModifyPreferencesRequestDTO } from '../models/ModifyPreferencesRequestDTO';
import type { PreferencesDTO } from '../models/PreferencesDTO';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class PreferencesApiService {

    /**
     * Get User Preferences
     * Retrieves all preferences for the authenticated user
     * @param userId
     * @returns PreferencesDTO OK
     * @throws ApiError
     */
    public static getPreferences(
        userId: string,
    ): CancelablePromise<PreferencesDTO> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/preferences/{userId}',
            path: {
                'userId': userId,
            },
            errors: {
                400: `Invalid request`,
                401: `Unauthorized`,
                422: `Unprocessable Entity`,
                500: `Server error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * Modify User Preferences
     * Update specific user preferences. Unspecified preferences retain their current values.
     * @param userId
     * @param requestBody
     * @returns string OK
     * @throws ApiError
     */
    public static modifyPreferences(
        userId: string,
        requestBody: ModifyPreferencesRequestDTO,
    ): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/preferences/{userId}',
            path: {
                'userId': userId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Invalid request or preference`,
                401: `Unauthorized`,
                422: `Unprocessable Entity`,
                500: `Server error`,
                501: `Not Implemented`,
            },
        });
    }

}
